import { Quest, QuestStatus } from '../services/QuestsService.schemas';

export const filterInGameQuests = (quests: Quest[], gameId: number) =>
  quests.filter(
    (quest) =>
      quest.status.match(
        `${QuestStatus.OptIn}|${QuestStatus.InProgress}|${QuestStatus.Completed}`,
      ) && quest.subTypeMeta.gameIds?.indexOf(gameId) !== -1,
  );

export const getNextUpcomingQuest = (quests: Quest[]): Quest | undefined => {
  const questsByStartTime = [...quests].sort((a: Quest, b: Quest) =>
    new Date(a.startDate).getTime() > new Date(b.startDate).getTime() ? 1 : -1,
  );

  return questsByStartTime.find(
    (quest: Quest) => new Date(quest.startDate).getTime() > Date.now(),
  );
};

export const getNextExpiringQuest = (quests: Quest[]): Quest | undefined =>
  [...quests].sort(
    (q1, q2) => new Date(q1.endDate).getTime() - new Date(q2.endDate).getTime(),
  )[0];
